module.exports = "<div class=\"text-center modal-dialog\">\n  <h3>Are you sure you want to remove this damaged area.</h3>\n  <div>\n    <a class=\"btn btn-primary\" #deleteMark (click)=\"DeleteMark()\">Yes</a>\n    <a class=\"btn btn-default\" (click)=\"Cancel()\">No</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/confirm-modal/confirm-modal.component.html
// module id = ../../../../../src/app/modals/confirm-modal/confirm-modal.component.html
// module chunks = main